import React from 'react'
import ReactModal from 'react-modal'
import CloseBtn from '../../buttons/CloseBtn'
import { Form } from 'react-bootstrap'
import RequieredInputs from '../../common/RequiredInputs'
import { BusinessUnitMultiSelect } from '../../fields'

const NewCategoriesModal = ({
  newCategories,
  modalIsOpen,
  closeModal,
  handleSubmit,
  handleChange,
  validateForm,
  textBtn,
}) => {
  const customStyles = {
    content: {
      width: '60%',
    },
  }

  return (
    <ReactModal
      isOpen={modalIsOpen}
      onRequestClose={closeModal}
      contentLabel='Añadir Categoría'
      className='custom-modal'
      style={customStyles}
    >
      <span className='custom-modal__close close-btn' onClick={closeModal}>
        <CloseBtn />
      </span>
      <h4 className='custom-modal__title'>Añadir nueva categoría</h4>
      <Form onSubmit={handleSubmit} className='products__form'>
        <div>
          <Form.Group controlId='product-name'>
            <Form.Label className='form__labels'>
              Categoría <RequieredInputs />{' '}
            </Form.Label>
            <Form.Control
              className='user-input name'
              type='text'
              name='nombre'
              value={newCategories.nombre}
              onChange={handleChange}
              placeholder='Nombre de la categoría'
            />
          </Form.Group>
        </div>

        <div>
          <BusinessUnitMultiSelect
            value={newCategories.businessUnits || []}
            onChange={(selectedIds) =>
              handleChange({
                target: {
                  name: 'businessUnits',
                  value: selectedIds,
                },
              })
            }
            label='Unidades de Negocio'
            placeholder='Selecciona las unidades de negocio para esta categoría...'
            required
          />
        </div>

        <div className='container__buttons'>
          <button
            onClick={handleSubmit}
            disabled={!validateForm()}
            className='btn save create'
          >
            {textBtn}
          </button>
        </div>
      </Form>
    </ReactModal>
  )
}
ReactModal.setAppElement('#root')
export default NewCategoriesModal
